export default "__VITE_ASSET__Cc$gl64P__"